import {HTTP} from '@/common/utils/http';
import {QueryParams} from '@/common/utils/query-params';
import {PaginationParams} from '@/common/utils/pagination-params';

export const InvoicesService = {
    getInvoices(schoolId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/invoices`);
        return HTTP.get(url);
    },

    getInvoice(schoolId, invoiceId) {
        return HTTP.get(`/schools/${schoolId}/invoices/${invoiceId}`);
    },

    downloadInvoicePdf(schoolId, invoiceId) {
        return HTTP.get(`/schools/${schoolId}/invoices/${invoiceId}/full-info/pdf`);
    },

    sendInvoiceReceipt(schoolId, invoiceId) {
        //TODO change when will be ready endpoint
        //return HTTP.get(`/schools/${schoolId}/invoices/${invoiceId}/invoice-pdf`);
    },

    saveNewMemo(schoolId, id, note) {
        //TODO change when will be ready endpoint
        //return HTTP.get(`/schools/${schoolId}/invoices/${invoiceId}/invoice-pdf`);
    },

    addInvoice(schoolId, form) {
        return HTTP.post(`schools/${schoolId}/invoices`, form);
    },

    getClassRostersInvoicePaymentInfo(schoolId, { activityId, couponCode, activityType, listType, childId }) {
        const url = QueryParams
            .createParams({
                couponCode,
                activityType: _.upperCase(activityType),
                childId
            })
            .applyToUrl(`/schools/${schoolId}/classes/${activityId}/cart`);
        return HTTP.get(url);
    },

    getCampRostersInvoicePaymentInfo(schoolId, { activityId, couponCode, activityType, listType, childId }) {
        const url = QueryParams
            .createParams({
                couponCode,
                activityType: _.upperCase(activityType),
                childId
            })
            .applyToUrl(`/schools/${schoolId}/camp-pricing/${activityId}/cart`);
        return HTTP.get(url);
    },

    getAftercareRostersInvoicePaymentInfo(schoolId, { activityId, couponCode, activityType, listType, childId, form }) {
        const url = QueryParams
            .createParams({
                couponCode,
                childId,
                activityType: _.upperCase(activityType),
                listType: _.upperCase(listType),
                sunday: form.sunday,
                monday: form.monday,
                tuesday: form.tuesday,
                wednesday: form.wednesday,
                thursday: form.thursday,
                friday: form.friday,
                saturday: form.saturday
            })
            .applyToUrl(`/schools/${schoolId}/aftercare/${activityId}/cart`);

        return HTTP.get(url);
    },

    getAftercareDropinInvoicePaymentInfo(schoolId, { activityId, couponCode, activityType, listType, childId, form }) {
        const url = QueryParams
            .createParams({
                couponCode,
                childId,
                activityType: _.upperCase(activityType),
                listType: _.upperCase(listType),
                dates: form.dates || form
            })
            .applyToUrl(`/schools/${schoolId}/aftercare/${activityId}/cart`);
        return HTTP.get(url);
    },

    removeAddonFromActivity(schoolId, id, addOnId, activityType, listType) {
        const url = QueryParams
            .createParams({
                activityType: (activityType === 'Aftercare' && listType === 'Dropin') ? _.upperCase(listType) : _.upperCase(activityType),
                addOnId
            })
            .applyToUrl(`/schools/${schoolId}/rosters/${id}/cart/addon`);
        return HTTP.delete(url);
    },

    makeParentPay(schoolId, id, listType, form) {
        return HTTP.post(`/schools/${schoolId}/${_.lowerCase(listType)}/${id}/payment`, form);
    },

    deleteInvoice(schoolId, invoiceId) {
        return HTTP.delete(`/schools/${schoolId}/invoices/${invoiceId}`);
    },

    deleteMultipleInvoices(schoolId, invoiceIds) {
        return HTTP.delete(`/schools/${schoolId}/invoices?invoiceIds=${invoiceIds}`);
    },

    invoiceBulkResend(schoolId, ids) {
        return HTTP.put(`/schools/${schoolId}/invoices?invoiceIds=${ids}`);
    },

    invoiceResend(schoolId, id) {
        return HTTP.put(`/schools/${schoolId}/invoices/${id}`);
    },
    getXlsFileFieldNames(schoolId) {
        return HTTP.get(`/schools/${schoolId}/overdue-invoices/xls-fields`);
    },
};


// WEBPACK FOOTER //
// ./src/common/services/pages/invoices.service.js